import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SeoService } from '../../services/seo.service';
import { StarFieldComponent } from '../star-field/star-field';

@Component({
  selector: 'app-splash',
  standalone: true,
  imports: [CommonModule, RouterModule, StarFieldComponent],
  templateUrl: './splash.html',
  styleUrl: './splash.scss',
})
export class SplashComponent implements OnInit, OnDestroy {
  constructor(private readonly seo: SeoService) {}

  ngOnInit(): void {
    const description =
      'Spark Server Framework is a strongly typed Node.js runtime that unifies Express controllers, WebSockets, Sequelize, and OpenAPI 3.1 generation.';

    this.seo.updateTags({
      title: 'Spark Server Framework | Typed Node.js Runtime by Spark Business Technology',
      description,
      keywords: [
        'spark server framework',
        'typed node runtime',
        'express controllers',
        'openapi 3.1',
        'spark business technology',
      ],
      siteName: 'Spark Business Technology',
      type: 'website',
      canonicalPath: '/',
      url: this.seo.resolveUrl('/'),
    });

    this.seo.setJsonLd('splash-ld-json', {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: 'Spark Server Framework',
      applicationCategory: 'DeveloperApplication',
      operatingSystem: 'Cross-platform',
      description,
      url: this.seo.resolveUrl('/'),
      publisher: {
        '@type': 'Organization',
        name: 'Spark Business Technology',
        url: 'https://sparkbusinesstechnology.com.au',
      },
      offers: {
        '@type': 'Offer',
        price: '100',
        priceCurrency: 'AUD',
        priceSpecification: {
          '@type': 'UnitPriceSpecification',
          price: '100',
          priceCurrency: 'AUD',
          billingIncrement: 1,
          unitCode: 'MON',
        },
        availability: 'https://schema.org/InStock',
      },
    });
  }

  ngOnDestroy(): void {
    this.seo.removeJsonLd('splash-ld-json');
  }
}
